import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the address-search endpoint.
 *
 * @param zipcode  - ZIP code to search
 * @param user_uuid - Optional user UUID for logging
 * @param role     - Optional role override (defaults to canvas detection in the service)
 * @param testRecord - Optional Salesforce test-lead indicator
 */
export function buildAddressSearchConfig(
  zipcode: string,
  user_uuid?: string,
  role?: string,
  testRecord?: boolean,
): ApiCallConfig {
  const body: Record<string, string | boolean> = { zipcode };

  if (user_uuid) {
    body.user_uuid = user_uuid;
  }

  if (role) {
    body.role = role;
  }

  if (testRecord) {
    body.test_record = true;
  }

  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.ADDRESS_SEARCH,
    body,
  };
}
